import { debounce } from 'lodash';
import Marquee from '@/modules/Marquee/Marquee.js';

class CitiesList {
  constructor(rootElement) {
    this.rootElement = rootElement;
    this.marquee = null;

    this.config = {
      marqueePoint: 1300,
    };

    this.findElements();
    this.saveListBoxInitialDom();
    this.init();
    this.attachEvents();
  }

  findElements() {
    this.listBox = this.rootElement.querySelector('[data-entity="marquee-box"]');
  }

  saveListBoxInitialDom() {
    this.listBoxInitialDom = this.listBox.innerHTML;

    this.listBoxInitialDom = this.listBoxInitialDom.replace(/lozad/g, '');
    this.listBoxInitialDom = this.listBoxInitialDom.replace(/data-src/g, 'src');
  }

  init() {
    if (window.innerWidth < this.config.marqueePoint) return;

    this.initMarquee();
  }

  initMarquee() {
    const element = this.rootElement.querySelector('[data-entity="marquee"]');
    this.marquee = new Marquee(element);
  }

  destroyMarquee() {
    this.marquee.destroy();
    this.marquee = null;
    this.listBox.innerHTML = this.listBoxInitialDom;
  }

  attachEvents() {
    const debouncedHandler = debounce(this.windowResizeHandler.bind(this), 400);
    window.addEventListener('resize', debouncedHandler);
  }

  windowResizeHandler() {
    if (window.innerWidth >= this.config.marqueePoint) {
      this.initMarquee();
    }

    if (this.marquee && window.innerWidth < this.config.marqueePoint) {
      this.destroyMarquee();
    }
  }
}

export default CitiesList;
